import ApiService from "@/services/api.service"

export const OnlineBookingService = {
  getOnlineBookingServices() {
    return ApiService.get(`online_booking/services`)
  },
  saveOnlineBookingServices(params) {
    return ApiService.post(`online_booking/services`, params)
  },
  sendFeedbackUrlToPatientThroughMessenger(params) {
    return ApiService.post(`feedback/url/send`, params)
  }
}
